/**
 * Product gallery: Swiper main + thumbs, loop. Requires Swiper (e.g. from CDN).
 * Use with snippet product-media-gallery-swiper.liquid
 */
(function () {
  function initGallery(container) {
    if (typeof window.Swiper === 'undefined') return;
    var mainEl = container.querySelector('[data-gallery-main]');
    var thumbsEl = container.querySelector('[data-gallery-thumbs]');
    if (!mainEl) return;

    // サムネクリック時の「スクロール要求」。Swiperの切り替え完了後に実行するためのフラグ
    var pendingThumbScroll = false;
    // transitionEnd 不発/ズレを考慮して、タイマーでも確実にスクロールする
    var thumbScrollTimer = null;

    function scrollToMediaArea() {
      if (typeof window.scrollTo !== 'function') return;

      var currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

      // currentScrollTop が 0 のときは全部見えている → スクロールしない
      if (currentScrollTop <= 90) return;

      // CSS の scroll-behavior: smooth が効いて「なめらかに」動くのを止める
      // （一時的に auto に差し替えてから戻す）
      var html = document.documentElement;
      var prevHtmlScrollBehavior = html.style.scrollBehavior;
      var prevBodyScrollBehavior = '';
      if (document.body && document.body.style) prevBodyScrollBehavior = document.body.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      if (document.body && document.body.style) document.body.style.scrollBehavior = 'auto';

      window.scrollTo(0, 90);

      // 次の描画フレームで元に戻す（以降の操作に影響させない）
      setTimeout(function () {
        html.style.scrollBehavior = prevHtmlScrollBehavior;
        if (document.body && document.body.style) document.body.style.scrollBehavior = prevBodyScrollBehavior;
      }, 0);
    }

    function setThumbActiveByIndex(index) {
      if (!thumbsEl) return;
      var slides = thumbsEl.querySelectorAll('.product-gallery-swiper__thumb-slide');
      slides.forEach(function (el) { el.classList.remove('swiper-slide-thumb-active'); });
      // ループ時は複製スライドがあるので、ボタンの data-index で一致させる
      var btn = thumbsEl.querySelector('.product-gallery-swiper__thumb-btn[data-index="' + index + '"]');
      if (btn && btn.closest) {
        var slide = btn.closest('.product-gallery-swiper__thumb-slide');
        if (slide) slide.classList.add('swiper-slide-thumb-active');
      }
    }

    var isMobileThumbs = false;
    try {
      // モバイルだけサムネを Swiper 表示にする（PCはグリッドで固定表示にしたい）
      isMobileThumbs = window.matchMedia('(max-width: 749px)').matches;
    } catch (e) {
      isMobileThumbs = false;
    }

    var thumbsSwiper = null;
    var thumbsLayout = thumbsEl ? (thumbsEl.getAttribute('data-gallery-layout') || '') : '';
    // thumbnail の時は PC はグリッド固定 / thumbnail_slider は PC でも横スライド表示
    var enableThumbsSwiper = isMobileThumbs || thumbsLayout === 'thumbnail_slider';
    if (thumbsEl && enableThumbsSwiper) {
      thumbsSwiper = new window.Swiper(thumbsEl, {
        speed: 300,
        spaceBetween: 8,
        watchSlidesProgress: true,
        loop: isMobileThumbs,
        // モバイルでもサムネ1枚をコンテナ幅に引き伸ばさないため 'auto'
        // ただし slidesPerGroup=1 で「1枚ずつ」スナップ感を出す
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        freeMode: false,
        // centeredSlides はループ時に端の複製が目立つので使わない。表示は slideToLoop で追従
        centeredSlides: false,
        breakpoints: {
          750: { slidesPerView: 4 },
          990: { slidesPerView: 5 }
        }
      });
    }

    var mainSwiper = new window.Swiper(mainEl, {
      speed: 300,
      loop: true,
      // モバイルは95vw幅なので 'auto' で実際の幅を読ませないと位置がズレる。PCは1枚表示
      slidesPerView: isMobileThumbs ? 'auto' : 1,
      spaceBetween: 10,
      threshold: 5,
      centeredSlides: isMobileThumbs,
      /* thumbs オプションは使わない。双方向 sync でクリック時に thumbs のずれた realIndex が main を上書きするため、slideChange で main→thumbs のみ手動同期 */
      navigation: {
        prevEl: mainEl.querySelector('.swiper-button-prev'),
        nextEl: mainEl.querySelector('.swiper-button-next')
      },
      pagination: {
        el: mainEl.querySelector('.swiper-pagination'),
        clickable: true
      },
      on: {
        init: function () {
          this.update();
        },
        slideChange: function () {
          var slide = this.slides[this.activeIndex];
          if (!slide) return;
          if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
          var deferred = slide.querySelector('.deferred-media');
          if (deferred && typeof deferred.loadContent === 'function') deferred.loadContent(false);
          var cur = mainEl.querySelector('.slider-counter--current');
          if (cur) cur.textContent = this.realIndex + 1;

          // thumb がactiveになったのに位置が追従せず切れるのを防ぐ
          if (thumbsSwiper && isMobileThumbs) {
            // realIndex は 0..(originalSlides-1)。thumbs 側も loop 対応のため slideToLoop を使う
            thumbsSwiper.slideToLoop(this.realIndex, 300);
          }

          // クリック/スワイプどちらでも active サムネの見た目を保証
          setThumbActiveByIndex(this.realIndex);
        },
        slideChangeTransitionEnd: function () {
          // PCのサムネクリックでのみ「表示エリアに戻す」目的のスクロールを行う
          if (!pendingThumbScroll || isMobileThumbs) return;
          pendingThumbScroll = false;
          // transitionEnd 直後のタイミングだと sticky / レイアウト再計算でズレることがあるため、
          // スクロールは thumb click 側の setTimeout に統一する
        }
      }
    });
    if (typeof requestAnimationFrame !== 'undefined') {
      requestAnimationFrame(function () { mainSwiper.update(); });
    }

    // Thumb buttons: click to go to index (in case thumbs sync is not enough)
    if (thumbsEl) {
      thumbsEl.querySelectorAll('.product-gallery-swiper__thumb-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = parseInt(btn.getAttribute('data-index') || '0', 10);
          if (!isNaN(idx)) {
            mainSwiper.slideToLoop(idx);
            // ループで同じdata-indexの複製があるので、クリックしたスライドに直接activeを付ける
            var slides = thumbsEl.querySelectorAll('.product-gallery-swiper__thumb-slide');
            slides.forEach(function (el) { el.classList.remove('swiper-slide-thumb-active'); });
            var clickedSlide = btn.closest && btn.closest('.product-gallery-swiper__thumb-slide');
            if (clickedSlide) clickedSlide.classList.add('swiper-slide-thumb-active');

            // PCのみ: slide 切り替え完了後に 1回だけスクロール（transitionEnd 不発/ズレ対策でタイマー併用）
            if (!isMobileThumbs) {
              pendingThumbScroll = false;
              if (thumbScrollTimer) clearTimeout(thumbScrollTimer);
              thumbScrollTimer = null;
              // 「パッと移動」優先で即時スクロール
              scrollToMediaArea();
            }
          }
        });
      });
    }

    // 初期表示の active も揃える（PCで thumbsSwiper 無効のケース）
    if (thumbsEl) {
      requestAnimationFrame(function () {
        var idx = mainSwiper.realIndex;
        setThumbActiveByIndex(idx);
      });
    }
  }

  function run() {
    document.querySelectorAll('.product-gallery-swiper').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
